import { combineReducers } from 'redux';
import { navigationReducer } from '@Header/Navigation/ducks/reducers';
import { purchaseDetailsReducer } from '@Header/Account/ducks/reducers';
import { modalsReducer } from '@Header/Modals/ducks/reducers';

import * as types from './types';
import initialState from './state';
import { shouldDisplayCampaignPromotion, shouldDisplayPromotion } from './utils';

export const checkIfMobile = state => state.ui.screenSize.isMobile;
export const getScreenHeight = state => state.ui.screenSize.height;

const headerReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_TRADE_SUCCESS: {
      return {
        ...state,
        trade: action.trade
      };
    }
    case types.FETCH_TRADE_IN_PROGRESS:
      return {
        ...state,
        tradeRequestInProgress: action.isInProgress,
        isTradeRequestCompleted: !action.isInProgress
      };
    case types.FETCH_SHOULD_FIRE_HEADER_EVENTABLE_PAGE_LOAD_EVENT_BEGIN:
      return {
        ...state,
        shouldFireHeaderEventablePageLoadEventStatus: {
          ...state.shouldFireHeaderEventablePageLoadEventStatus,
          isLoading: true,
          isError: false
        }
      };
    case types.FETCH_SHOULD_FIRE_HEADER_EVENTABLE_PAGE_LOAD_EVENT_SUCCESS:
      return {
        ...state,
        shouldFireHeaderEventablePageLoadEventStatus: {
          ...state.shouldFireHeaderEventablePageLoadEventStatus,
          isLoading: false,
          isError: false,
          shouldFireHeaderEventablePageLoadEvent: action.payload
        }
      };
    case types.FETCH_SHOULD_FIRE_HEADER_EVENTABLE_PAGE_LOAD_EVENT_FAILURE:
      return {
        ...state,
        shouldFireHeaderEventablePageLoadEventStatus: {
          ...state.shouldFireHeaderEventablePageLoadEventStatus,
          isLoading: false,
          isError: true
        }
      };
    case types.SET_FAVORITES: {
      return {
        ...state,
        ...action.favorites
      };
    }
    case types.SET_ACCOUNT_URLS: {
      return {
        ...state,
        useModalUrlForAccountLinks: action.payload
      };
    }
    // note(oscar): if "campaign" discounts are available for state, then promotions are displayed.
    // which component is displaying and where does HeaderBannersAndModals come from in the state object?
    // note(oscar): it appears SET_CAMPAIGN_PROMOTIONS doesn't appear anywhere because this state object no longer exists
    case types.SET_CAMPAIGN_PROMOTIONS: {
      if (!state.HeaderBannersAndModals) {
        return { ...state };
      }
      const enabledPromotions = state.HeaderBannersAndModals.promotions.filter(
        promo =>
          shouldDisplayPromotion(promo, state.geolocation) ||
          shouldDisplayCampaignPromotion(promo, state)
      );
      return {
        ...state,
        enabledPromotions
      };
    }
    case types.SET_ENABLED_PROMOTIONS: {
      return {
        ...state,
        enabledPromotions: action.payload
      };
    }
    case types.SET_GEOLOCATION: {
      return {
        ...state,
        geolocation: action.geolocation
      };
    }
    case types.SET_APP_SETTINGS: {
      return {
        ...state,
        ...action.appSettings
      };
    }
    case types.SET_IS_IN_DOT_COM: {
      return {
        ...state,
        isInDotCom: action.payload
      };
    }
    default:
      return state;
  }
};

const discountsInitialState = {
  discountsForFavorites: {
    discounts: []
  },
  discountsRequestStatus: {
    isLoading: false,
    isError: false
  }
};
const discountsReducer = (state = discountsInitialState, action) => {
  switch (action.type) {
    case types.GET_DISCOUNTS_LOADING:
      return {
        ...state,
        discountsRequestStatus: {
          ...state.discountsRequestStatus,
          isLoading: true,
          isError: false
        }
      };
    case types.GET_DISCOUNTS_SUCCESS:
      return {
        ...state,
        discountsRequestStatus: {
          ...state.discountsRequestStatus,
          isLoading: false,
          isError: false
        },
        discountsForFavorites: {
          discounts: action.discounts
        }
      };
    case types.GET_DISCOUNTS_ERROR:
      return {
        ...state,
        discountsRequestStatus: {
          ...state.discountsRequestStatus,
          isLoading: false,
          isError: true
        },
        discountsForFavorites: {
          ...state.discountsForFavorites,
          error: action.error
        }
      };
    default:
      return state;
  }
};

const partnerInitialState = {
  partnerId: 1,
  partnerKey: 'Carvana',
  partnerLongName: 'Carvana',
  partnerVanityUrlName: 'notused',
  partnerWhisperNumber: '1.800.333.4554',
  isExtendedWarrantyOffered: true
};
const profileInitialState = {
  userProfile: null,
  isAuthorized: false,
  isImpersonating: false,
  isLoggedIn: false,
  partner: partnerInitialState,
  isAwaitingProfileResponse: false
};
export const profileReducer = (state = profileInitialState, action) => {
  switch (action.type) {
    case types.REQUEST_PROFILE:
      return {
        ...state,
        isAwaitingProfileResponse: true
      };
    // note(oscar): where does this action get dispatched and how does it relate to login state?
    case types.REQUEST_PROFILE_SUCCESS:
      return {
        ...state,
        ...action.payload,
        // note(oscar): what are these discounts related to and why are they here?
        discounts: action.payload.discounts || [],
        isAwaitingProfileResponse: false
      };
    case types.REQUEST_PROFILE_ERROR:
      return {
        ...state,
        // todo(oscar): does this need to update any additional state?
        isAwaitingProfileResponse: false
      };
    default:
      return state;
  }
};

export default combineReducers({
  header: headerReducer,
  profile: profileReducer,
  modals: modalsReducer,
  purchaseDetails: purchaseDetailsReducer,
  discounts: discountsReducer,
  navigation: navigationReducer
});
